import { render, staticRenderFns } from "./ArticleTextModule.vue?vue&type=template&id=20c7315e&"
import script from "./ArticleTextModule.ts?vue&type=script&lang=ts&"
export * from "./ArticleTextModule.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports